import { render } from "./Yanjiu.vue?vue&type=template&id=8a30eeda&scoped=true"
import script from "./Yanjiu.vue?vue&type=script&lang=js"
export * from "./Yanjiu.vue?vue&type=script&lang=js"

import "./Yanjiu.vue?vue&type=style&index=0&id=8a30eeda&scoped=true&lang=css"

import exportComponent from "D:\\lxq\\nkpcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a30eeda"]])

export default __exports__